import { Component, computed, inject } from '@angular/core';

import { ConfirmationService } from './confirmation.service';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss',
})
export class ConfirmationModalComponent {
  private readonly confirmationService = inject(ConfirmationService);

  readonly dialog = this.confirmationService.dialog;
  readonly isDanger = computed(() => this.dialog().tone === 'danger');

  confirm(): void {
    this.confirmationService.accept();
  }

  cancel(): void {
    this.confirmationService.dismiss();
  }
}
